import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import {persistRules} from  './persistRulesReducer';
import {updatePasswordReducer} from '../reducers/updatePass-reducer';

import { authReducer } from './../reducers/auth-reducer';
import { renewPasswordReducer } from './../reducers/renewPassword-reducer';
import { shoppingCartReducer } from './../reducers/shoppingCart-reducer';
import { productReducer } from './../reducers/product-reducer';
import { categoryReducer } from '../reducers/category-reducer';
import { orderReducer } from '../reducers/order-reducer';
import { addAddressReducer } from '../reducers/deliveryAddress-reducer';

const appReducer = combineReducers({
	authReducer: persistReducer(persistRules.authPersistConfig, authReducer),
	renewPassword: persistReducer(persistRules.renewPasswordPersistConfig, renewPasswordReducer),
	categoryReducer,
	cart: shoppingCartReducer,
	order: orderReducer,
	productReducer,
	addAddressReducer,
	updatePasswordReducer
});

const rootReducer = (state: any, action: any) => {
	return appReducer(state, action);
}

export default rootReducer;
